import { WallBoard } from '../../board/WallBoard';

import type { WallBoard as WallBoardModel } from '@walls/store';

interface WallBoardSurfaceProps {
  board: WallBoardModel;
}

export function WallBoardSurface({ board }: WallBoardSurfaceProps) {
  return <WallBoard board={board} />;
}
